module.exports = __webpack_public_path__ + "static/desktop/img/group-lovers.5102b71c.png";